(function () {
  function init(root) {
    root.querySelectorAll("[data-fsh-section]:not([data-fsh-ready])").forEach((section) => {
      section.setAttribute("data-fsh-ready", "true");
      const items = section.querySelectorAll(".fsh-reveal");

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        items.forEach((item) => item.classList.add("on"));
        return;
      }

      window.requestAnimationFrame(() => {
        items.forEach((item, index) => {
          window.setTimeout(() => item.classList.add("on"), index * 80);
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
